












import { Component, Vue, Prop } from 'vue-property-decorator';
import AppVue from '@/AppVue.vue';
import DialogCpt from './DialogCpt.vue';

@Component({
  components: {
    DialogCpt,
  },
})
export default class ConfirmDialogCpt extends AppVue {
  @Prop({ default: false }) showDialog: boolean;
  @Prop() title: string;
  @Prop() message: string;
  @Prop({ default: 'confirm-dialog' }) elementId!: string;

  get isOpen() {
    return this.showDialog;
    //
  }

  closeResult(result: boolean) {
    this.$emit('close', result);
  }
}
